import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { usePermissions } from "@/hooks/use-permissions";
import { PageContentSkeleton } from "@/components/shared/page-content-skeleton";

/**
 * Route-level gate for the Knowledge Base surface. Renders the `/knowledge-base/*` routes only
 * when the company has knowledge base access — either its own `knowledgeBase.enabled` feature or
 * `voiceAgent.enabled`, which implies it — matching the nav gate (menu
 * `requiresPermission: "knowledgeBase"`); otherwise redirects to Home so collections can't be
 * reached by direct URL when the feature is off.
 */
export function KnowledgeBaseRouteGuard() {
  const { isLoading } = useAuth();
  const { knowledgeBaseEnabled } = usePermissions();
  if (isLoading) return <PageContentSkeleton variant="table" />;
  return knowledgeBaseEnabled ? <Outlet /> : <Navigate to="/home" replace />;
}
